import { CashDetails } from "../components/cash";
import { ChequeDetails } from "../components/cheque";
import { CustomerDetails } from "../components/customer";
import { FactorDetails } from "../components/factor";
import {
  useAlertStore,
  useChatStore,
  useDashboardStore,
  useGeneralStore,
  usePopupStore,
  useProgressStore,
  useUserStore,
} from "../stores";
import { ChatStatus } from "../types";
import { EventCbFn, EventHandlerMap, EventMap, IEvent } from "./types";

// ------------------------------------------- HANDLERS

// ------------------------------------------- USERS
const onUserStatusUpdate: EventCbFn<"UserStatusUpdate"> = (data) => {
  useGeneralStore.getState().updateUserStatus(data.id.$oid, data.status);
};

const onAddUser: EventCbFn<"AddUser"> = (data) => {
  useGeneralStore.getState().addUser(data);
};

const onUpdateUser: EventCbFn<"UpdateUser"> = (data) => {
  if (data._id.$oid !== useUserStore.getState().user?._id.$oid)
    useGeneralStore.getState().editUser(data);
  else useUserStore.getState().setUser(data);
};

const onDeleteUser: EventCbFn<"DeleteUser"> = (data) => {
  useGeneralStore.getState().deleteUser(data.$oid);
};

// ------------------------------------------- CUSTOMERS
const onAddCustomer: EventCbFn<"AddCustomer"> = (data) => {
  useGeneralStore.getState().addCustomer(data);
  useAlertStore
    .getState()
    .pushAlert("مشتری جدید ثبت شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore
        .getState()
        .setPopupBody(<CustomerDetails customer={data} />);
    });
};

const onUpdateCustomer: EventCbFn<"UpdateCustomer"> = (data) => {
  useGeneralStore.getState().editCustomer(data);
  useAlertStore
    .getState()
    .pushAlert("یک مشتری ویرایش شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore
        .getState()
        .setPopupBody(<CustomerDetails customer={data} />);
    });
};

const onDeleteCustomer: EventCbFn<"DeleteCustomer"> = (data) => {
  useGeneralStore.getState().deleteCustomer(data.id.$oid, data.activity);
  useAlertStore.getState().pushAlert("یک مشتری حذف شد.");
};

// ------------------------------------------- TAGS
const onAddTag: EventCbFn<"AddTag"> = (data) => {
  useGeneralStore.getState().addTag(data);
};

// ------------------------------------------- FACTORS
const onReceiveFactor: EventCbFn<"ReceiveFactor"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("فاکتور جدید دریافت شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore.getState().setPopupBody(<FactorDetails factor={data} />);
    });

  useDashboardStore.getState().activitiesAdd(data.activities[0]);
};

const onSpendFactor: EventCbFn<"SpendFactor"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("فاکتور جدید خرج شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore.getState().setPopupBody(<FactorDetails factor={data} />);
    });

  useDashboardStore.getState().activitiesAdd(data.activities[0]);
};

const onUpdateFactor: EventCbFn<"UpdateFactor"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("یک فاکتور ویرایش شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore.getState().setPopupBody(<FactorDetails factor={data} />);
    });

  useDashboardStore.getState().activitiesAdd(data.activities[0]);
};

const onDeleteFactor: EventCbFn<"DeleteFactor"> = (data) => {
  useAlertStore.getState().pushAlert("یک فاکتور حذف شد.");

  useDashboardStore.getState().activitiesAdd(data.activity);
};

// ------------------------------------------- Cash
const onAddCash: EventCbFn<"AddCash"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("نقدی جدید ثبت شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore.getState().setPopupBody(<CashDetails cash={data} />);
    });

  useDashboardStore.getState().activitiesAdd(data.activities[0]);
};

const onUpdateCash: EventCbFn<"UpdateCash"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("یک نقدی ویرایش شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore.getState().setPopupBody(<CashDetails cash={data} />);
    });

  useDashboardStore.getState().activitiesAdd(data.activities[0]);
};

const onDeleteCash: EventCbFn<"DeleteCash"> = (data) => {
  useAlertStore.getState().pushAlert("یک نقدی حذف شد.");

  useDashboardStore.getState().activitiesAdd(data.activity);
};

// ------------------------------------------- CHEQUE
const onConfirmCheque: EventCbFn<"ConfirmCheque"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("یک چک تایید شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore.getState().setPopupBody(<ChequeDetails {...data} />);
    });

  useDashboardStore.getState().activitiesAdd(data.activities[0]);
};

const onDeliverCheque: EventCbFn<"DeliverCheque"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("یک چک تحویل داده شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore.getState().setPopupBody(<ChequeDetails {...data} />);
    });

  useDashboardStore.getState().activitiesAdd(data.activities[0]);
};

const onUpdateCheque: EventCbFn<"UpdateCheque"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("یک چک ویرایش شد. برای دیدن کلیک کنید!", "info", () => {
      usePopupStore.getState().setPopupBody(<ChequeDetails {...data} />);
    });

  useDashboardStore.getState().activitiesAdd(data.activities[0]);
};

const onDeleteCheque: EventCbFn<"DeleteCheque"> = (data) => {
  useAlertStore.getState().pushAlert("یک چک حذف شد.");

  useDashboardStore.getState().activitiesAdd(data.activity);
};

// ------------------------------------------- CHAT
const onMessageSent: EventCbFn<"MessageSent"> = (data) => {
  useChatStore.getState().updateChatStatus(data, ChatStatus.Sent);
  useChatStore.getState().setNewMsgs((prev) => prev + 1);
};

const onMessageFailed: EventCbFn<"MessageFailed"> = (data) => {
  useChatStore.getState().updateChatStatus(data, ChatStatus.Failed);
};

const onNewMessage: EventCbFn<"NewMessage"> = (data) => {
  useChatStore.getState().addChat(data.chat.$oid, data.message);
  useChatStore.getState().setNewMsgs((prev) => prev + 1);
};

const onMessageDeleted: EventCbFn<"MessageDeleted"> = (data) => {
  useChatStore.getState().rmChat(data.chat.$oid, data.message.$oid);
  useChatStore.getState().setNewMsgs((prev) => prev - 1);
};

const onMessageDeleteFailed: EventCbFn<"MessageDeleteFailed"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("متاسفانه پیام شما حذف نشد. دوباره تلاش کنید!", "error");
};

const onDeleteMessage: EventCbFn<"DeleteMessage"> = (data) => {
  useChatStore.getState().rmChat(data.chat.$oid, data.message.$oid);
};

const onMessageUpdated: EventCbFn<"MessageUpdated"> = (data) => {
  useChatStore.getState().updateChat(data.chat.$oid, data.message);
};

const onMessageUpdateFailed: EventCbFn<"MessageUpdateFailed"> = (data) => {
  useAlertStore
    .getState()
    .pushAlert("متاسفانه پیام شما ویرایش نشد. دوباره تلاش کنید!", "error");
};

const onUpdateMessage: EventCbFn<"UpdateMessage"> = (data) => {
  useChatStore.getState().updateChat(data.chat.$oid, data.message);
};

// ------------------------------------------- FILE UPLOAD PROGRESS BAR
const onUploadProgress: EventCbFn<"UploadProgress"> = (data) => {
  useProgressStore.getState().updateProgress(data);
};

// ------------------------------------------- END OF HANDLERS

export const eventHandlerMap: EventHandlerMap = {
  UserStatusUpdate: onUserStatusUpdate,
  AddUser: onAddUser,
  UpdateUser: onUpdateUser,
  DeleteUser: onDeleteUser,

  AddCustomer: onAddCustomer,
  UpdateCustomer: onUpdateCustomer,
  DeleteCustomer: onDeleteCustomer,

  AddTag: onAddTag,

  ReceiveFactor: onReceiveFactor,
  SpendFactor: onSpendFactor,
  UpdateFactor: onUpdateFactor,
  DeleteFactor: onDeleteFactor,

  AddCash: onAddCash,
  UpdateCash: onUpdateCash,
  DeleteCash: onDeleteCash,

  ConfirmCheque: onConfirmCheque,
  DeliverCheque: onDeliverCheque,
  UpdateCheque: onUpdateCheque,
  DeleteCheque: onDeleteCheque,

  MessageSent: onMessageSent,
  MessageFailed: onMessageFailed,
  NewMessage: onNewMessage,
  MessageDeleted: onMessageDeleted,
  MessageDeleteFailed: onMessageDeleteFailed,
  DeleteMessage: onDeleteMessage,
  MessageUpdated: onMessageUpdated,
  MessageUpdateFailed: onMessageUpdateFailed,
  UpdateMessage: onUpdateMessage,

  UploadProgress: onUploadProgress,
};

const handleEvent = <T extends keyof EventMap>(event: IEvent<T>) => {
  if (eventHandlerMap[event.type]) eventHandlerMap[event.type](event.data);
};

export default handleEvent;
